<template>
  <div class="material-final-step">
    <p class="mfs-help">
      Tu informe se ha generado. Cuéntanos qué te pareció:
    </p>
    <FeedbackComponent :code="feedbackCode" />
    <div class="mfs-footer">
      <button class="mfs-finish-btn" @click="onFinish">{{ finishLabel }}</button>
    </div>
  </div>
</template>

<script>
import FeedbackComponent from "./FeedbackComponent.vue";

export default {
  name: "MaterialFinalStep",
  components: { FeedbackComponent },
  props: {
    context: { type: Object, required: true },
    canWork: { type: Boolean, required: false, default: false },
    // Default keeps shared chatbots' "Reiniciar chat" → go-to-step("reset").
    // Materiales IA passes a distinct label + step so shells that noop
    // toggle-reload can restart the pick flow without touching other chats.
    finishLabel: {
      type: String,
      required: false,
      default: "Reiniciar chat",
    },
    finishStep: {
      type: String,
      required: false,
      default: "reset",
    },
  },
  data() {
    // FeedbackEnum.MATERIAL_CHATBOT on the backend.
    return { feedbackCode: 3 };
  },
  methods: {
    onFinish() {
      this.$emit("go-to-step", this.finishStep);
    },
  },
};
</script>

<style scoped>
.material-final-step {
  padding: 10px 0;
  width: 100%;
}
.mfs-help {
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}
.mfs-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
.mfs-finish-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  border: none;
  border-radius: 10px;
  padding: 10px 20px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  background: #10b981;
}
</style>
